/*
  =====================================================
  FILE: product-embed-blogs.js
  
  DROP THIS FILE INTO: Shopify Admin → Themes → Edit Code → Assets
  
  THEN add this line inside theme.liquid just before </body>:
    {% if request.page_type == 'article' %}
      {{ 'product-embed-blogs.js' | asset_url | script_tag }}
    {% endif %}
  
  =====================================================
  MONTHLY EDIT: Change the two product handles below.
  Find a product's handle in its storefront URL:
  e.g. yourstore.com/products/MY-HANDLE-IS-HERE
  =====================================================
*/

const BPE_CONFIG = {
  product1: 'due2',   // ← EDIT THIS
  product2: 'turi-extra-virgin-olive-oil-500ml-bottle',  // ← EDIT THIS
  buttonText: 'Shop Now',                  // ← Optional: change button label
};

/* =====================================================
   DO NOT EDIT BELOW THIS LINE
   ===================================================== */

async function fetchProduct(handle) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    console.warn(`[Blog Product Embed] Could not load product: ${handle}`);
    return null;
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function buildCard(product) {
  if (!product) return '<div class="bpe-card bpe-card--empty"></div>';

  const image = product.featured_image
    ? `<a href="/products/${product.handle}" class="bpe-image-link">
         <img class="bpe-image" src="${product.featured_image}" alt="${product.title}" loading="lazy">
       </a>`
    : '';

  const comparePrice = product.compare_at_price_min > product.price_min
    ? `<span class="bpe-price-compare">${formatMoney(product.compare_at_price_min)}</span>`
    : '';

  return `
    <div class="bpe-card">
      ${image}
      <div class="bpe-card-body">
        <h3 class="bpe-title">
          <a href="/products/${product.handle}">${product.title}</a>
        </h3>
        <div class="bpe-price-row">
          <span class="bpe-price">${formatMoney(product.price_min)}</span>
          ${comparePrice}
        </div>
        <a href="/products/${product.handle}" class="bpe-button">
          ${BPE_CONFIG.buttonText}
        </a>
      </div>
    </div>
  `;
}

async function initBlogProductEmbed() {
  const wrappers = document.querySelectorAll('.bpe-wrapper');
  if (!wrappers.length) return;

  const [product1, product2] = await Promise.all([
    fetchProduct(BPE_CONFIG.product1),
    fetchProduct(BPE_CONFIG.product2),
  ]);

  const html = `
    <div class="bpe-container">
      <div class="bpe-grid">
        ${buildCard(product1)}
        ${buildCard(product2)}
      </div>
    </div>
  `;

  wrappers.forEach(wrapper => {
    wrapper.innerHTML = html;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogProductEmbed);
} else {
  initBlogProductEmbed();
}